import * as React from 'react';
import * as numeral from 'numeral';

import { ZoneSelectProps } from '../../components/cart/zone-select';
import { IZone } from '../../custom/classes/production';
import { sumPrices } from '../../helpers/pricing-helpers';

const ZoneSelectView: React.StatelessComponent<ZoneSelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        props.selectZone(props.itemId, selectedValue);
    }


    return (
        <div className="space-top-sm">
            {
                props.selectedZone == null && props.venueZoneMapImageUrl != null ?
                    <div className="ace-flex-zone-map"><img src={props.venueZoneMapImageUrl} /></div>
                    : null
            }

            <div className="">
                {
                    props.requiresPriceTypeSelection ?
                        (
                            props.showPriceTypeError && props.zones.length > 0
                                ?
                                <p className="error-message">
                                    <a href="#quantitySelect">
                                        {props.missingPriceTypeSelectionMessage}
                                    </a>
                                </p>
                                : null)
                        :
                        (
                            (props.selectedZone != null && props.selectedZone.zone.id > 0) ?
                                <div className="flex-between">
                                    <span className="bold">{props.selectedZone.zone.description}</span>
                                    <span>{numeral(sumPrices(props.selectedZone, props.selectedPriceTypeQuantities).priceSum).format('$0,0.00')}</span>
                                </div>
                                :
                                <div className="stack-xs">
                                    <label htmlFor={props.itemId + "-quantity"}>
                                        { props.selectAZoneLabel }
                                    </label>
                                    <select name={props.itemId + "-quantity"} id={ props.itemId + "-quantity"} onChange={(evt) => {
                                        onChange(evt);
                                    }}>
                                        <option key={0} value={0}>
                                            {props.selectAZoneDropdownDefaultValue}
                                        </option>
                                        {
                                            props.zones.map(zone => {
                                                let { priceSum, foundAllPriceTypes } = sumPrices(zone, props.selectedPriceTypeQuantities);

                                                const price = numeral(priceSum).format('$0,0.00');

                                                const optionDisabled = !(zone.availableCount > Array.from(props.selectedPriceTypeQuantities.values()).reduce((total, num) => total + num, 0) && foundAllPriceTypes);

                                                const optionDisplay = `${zone.zone.description} - ${optionDisabled ? "Not Available" : price}`;


                                                return (<option disabled={optionDisabled} key={zone.zone.id} value={zone.zone.id}>{optionDisplay}</option>)
                                            })
                                        }
                                    </select>
                                </div>
                        )
                }
            </div>
        </div>
    );
}

export default ZoneSelectView;


